import { setLoading } from "redux/actions/app.actions";
import { openNotificationWithIcon } from "utils/Notification";
import { request } from "./verb.services";
import { getServerErrorString } from "utils/common";



export const getAllEarningPoints = (showLoading = true, callback) => {
    return (dispatch) => {
        if (showLoading) dispatch(setLoading(true));
        return request("LoyaltyPolicies", "get", null, true, null)
            .then((res) => {
                return {
                    status: "success",
                    data: res.data,
                };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                if (showLoading) dispatch(setLoading(false));
            });
    };
};

export const createEarningPoint = (values, callback) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`LoyaltyPolicies`, "post", values, true)
            .then((res) => {
                openNotificationWithIcon(
                    "success",
                    "Success",
                    "Earning points created successfully"
                );
                return { status: "success", data: res?.data };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};

export const updateEarningPoint = (id, data, callback) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`LoyaltyPolicies/${id}`, "put", data, true)
            .then(() => {
                openNotificationWithIcon(
                    "success",
                    "Success",
                    "Earning points updated successfully"
                );
                callback?.();
                return {
                    status: "success",
                };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};

export const getEarningPoint = (id, callback) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`LoyaltyPolicies/${id}`, "get", null, true)
            .then((res) => {
                return { status: "success", data: res.data };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};

export const deleteEarningPoint = (id, callback) => {
    return (dispatch) => {
        dispatch(setLoading(true));
        return request(`LoyaltyPolicies/${id}`, "delete", null, true)
            .then(() => {
                openNotificationWithIcon(
                    "success",
                    "Success",
                    "Earning points deleted successfully"
                );
                callback?.();
                return {
                    status: "success",
                };
            })
            .catch((e) => {
                openNotificationWithIcon(
                    "error",
                    "Error!",
                    getServerErrorString(e)
                );
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    };
};
